import { ISortOption, TStatusTab } from './types';
import { TTrendCardKPIConfigItem } from '@opm/pages/CreativeTrends/constants';
import { IMetricColumnConfig } from '@opm/pages/CreativeTrends/ListView';

/**
 * SORT_OPTIONS 的 value 直接使用 list.md 中的 `sort_item` 白名单字段名
 * （`tweets_view` / `tweets_like` / `videos`），便于直接透传到接口。
 */
export const SORT_OPTIONS: ISortOption[] = [
  { value: 'tweets_view', text: 'Views', order: 'desc' },
  { value: 'tweets_like', text: 'Likes', order: 'desc' },
  { value: 'videos', text: 'Videos', order: 'desc' },
];

export const STATUS_TAB_OPTIONS: {
  value: TStatusTab;
  text: string;
  textCn: string;
  tips: { en: string; zh: string };
}[] = [
  {
    value: 'hot',
    text: 'Hot',
    textCn: '热门',
    tips: {
      en: 'Trends with highest views in the selected period',
      zh: '所选时间范围内播放量最高的热门趋势',
    },
  },
  {
    value: 'rising',
    text: 'Rising',
    textCn: '上升',
    tips: {
      en: 'Trends with the fastest growing views recently',
      zh: '近期观看量增速最快的趋势',
    },
  },
  {
    value: 'new',
    text: 'New',
    textCn: '新兴',
    tips: {
      en: 'Newly discovered topics that first appeared within the selected period',
      zh: '首次出现在所选时间范围内的趋势话题',
    },
  },
];

export const DRAWER_RELATED_VIDEOS_COUNT = 8;

export const DEFAULT_PAGE_INFO = { page: 1, page_size: 20 };

/**
 * List 视图指标列：dataKey / maxKey / sortKey 都使用 API 真实字段名
 */
export const UGC_LIST_METRIC_COLUMNS: IMetricColumnConfig[] = [
  {
    key: 'tweets_view',
    dataKey: 'tweets_view',
    maxKey: 'tweets_view',
    headerTextKey: 'Views',
    width: 220,
    align: 'right',
    withHeaderIcon: true,
    sortKey: 'tweets_view',
  },
  {
    key: 'tweets_like',
    dataKey: 'tweets_like',
    maxKey: 'tweets_like',
    headerTextKey: 'Likes',
    width: 220,
    align: 'right',
    sortKey: 'tweets_like',
  },
  {
    key: 'videos',
    dataKey: 'videos',
    maxKey: 'videos',
    headerTextKey: 'Videos',
    width: 180,
    align: 'right',
    sortKey: 'videos',
  },
];

/**
 * KPI 配置：复用 UGC_LIST_METRIC_COLUMNS 的 dataKey + headerTextKey，
 * 避免 List / Card / Drawer 三处重复维护指标字段与 label。
 *
 * Card 视图（TTrendCardKPIConfigItem）与 Drawer Trend Info 区
 * （ITrendInfoKPIRowConfig）字段口径一致，结构同为 { dataKey; labelKey; decimal? }，
 * 故共用同一份配置。
 */
export const UGC_KPI_CONFIGS: TTrendCardKPIConfigItem[] =
  UGC_LIST_METRIC_COLUMNS.map(col => ({
    dataKey: col.dataKey,
    labelKey: col.headerTextKey,
  }));

export const LIST_FILTER_KEYS = [
  'UGCGame',
  'CTMultiDateRange',
  'UGCTrendsCategory',
  'UGCTrendsChannel',
] as const;

export const DETAIL_FILTER_KEYS = [
  'CTMultiDateRange',
  'UGCTrendsCountryRegion',
  'UGCTrendsChannel',
] as const;
